export const randomID = (length = 12) => {
  // nosemgrep: ajinabraham.njsscan.crypto_node.node_insecure_random_generator
  return (Math.random() * 10 ** length).toFixed();
};
